export const ACCESS_TOKEN = "accessToken";
export const REFRESH_TOKEN = "refreshToken";
export const API_TOKEN = "apiToken";
export const PRIVILEGES_TOKEN = "privilegesToken";
export const USER_UUID = "userUuid";
export const USER_TIMEZONE = "userTimezone";

export const REFRESH_INTERVAL_MILISECONDS = 10000;//10seg
export const REFRESH_INTERVAL_VERSION_MILISECONDS = 600000;//10min
export const REFRESH_INTERVAL_M2M_ALARMS_MILISECONDS = 905000;// 15 min 20sec
export const REFRESH_INTERVAL_RENEWALS_MILISECONDS = 3605000; // 1 hora 20sec 

export const STATE_EXPIRED = 'expired';
export const STATE_INACTIVE = 'inactive';
export const STATE_ACTIVE = 'active';
export const STATE_CANCELLED = 'cancelled';
export const STATE_NOT_APPLICABLE = 'not-applicable';

export const KICONEX_UUID = '90be8c8a-f462-4a3e-afcf-d8f34094eaa8';

// Gestión de firmware OTA
export const OTA_VERSIONS_VIEW = "otaVersionsView";
export const OTA_VERSIONS_PAGE_SIZE = 5;
export const OTA_VERSION_CARDS_PAGE_SIZE = 16;

// Password policy
export const PASSWORD_UPDATED_AT = "passwordUpdatedAt";
export const PASSWORD_VALIDITY_DAYS = 180;
export const PASSWORD_WARNING_SHOWN = "passwordWarningShown";
export const PASSWORD_WARNING_DAYS = 30;
export const PASSWORD_EXPIRED_MODAL_SHOWN = "passwordExpiredModalShown";
